import _get from "lodash/get";

import Bluetooth from "./bluetooth";
import Headset from "./headset";
import Keyboard from "./keyboard";
import Lighting from "./lighting";
import Monitor from "./monitor";
import Mouse from "./mouse";
import Streaming from "./streaming";
import UsbC from "./usb-c";
import Vr from "./vr";
import Wifi from "./wifi";

const defaultSize = {
	width: 35,
	height: 35,
	positionY: 0,
	positionX: 0
};

const icons = {
	lighting: (data) => {
		return {
			icon: Lighting,
			featureName: "RGB Lighting",
			name: "rgbLighting",
			tooltip: {
				included: "This build is equipped with RGB components.",
				missing: "This build is not equipped with RGB components.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}), positionX: -1 }
		};
	},
	wifi: (data) => {
		return {
			icon: Wifi,
			featureName: "WiFi",
			name: "wifi",
			tooltip: {
				included: "This build is WIFI ready.",
				missing: "This build does not have built-in WiFi capability.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}), positionX: -1 }
		};
	},
	bluetooth: (data) => {
		return {
			icon: Bluetooth,
			featureName: "Bluetooth",
			name: "bluetooth",
			tooltip: {
				included: "This build has Bluetooth capability for use with wireless Bluetooth products.",
				missing: "This build does not have Bluetooth capability for use with wireless Bluetooth products.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}), positionX: -10 }
		};
	},
	usbc: (data) => {
		return {
			icon: UsbC,
			featureName: "USB-C",
			name: "usbC",
			tooltip: {
				included: "USB-C port on the front I/O panel of the case is functional.",
				missing: "USB-C port on the front I/O panel of the case is not functional.",
				..._get(data, "tooltip", {})
			},
			size: {
				...defaultSize,
				..._get(data, "size", {}),
				positionY: -10,
				positionX: -1
			}
		};
	},
	vr: (data) => {
		return {
			icon: Vr,
			featureName: "VR Ready",
			name: "vrReady",
			tooltip: {
				included: "This build meets the minimum recommended specs for VR functionality.",
				missing: "VR is not recommended for this configuration.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}), positionX: -5 }
		};
	},
	streaming: (data) => {
		return {
			icon: Streaming,
			featureName: "Stream Ready",
			name: "streamReady",
			tooltip: {
				included: "This build will be capable of streaming most games in 720p with 60fps (internet speeds permitting). Games can only be streamed at 60+ FPS when running at 60+ FPS.",
				missing: "Streaming not recommended for this build.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}), positionX: -3 }
		};
	},
	monitor: (data) => {
		return {
			icon: Monitor,
			featureName: "Monitor",
			name: "monitor",
			tooltip: {
				included: "You have a monitor in your cart.",
				missing: "You do not have a monitor with your build.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}) }
		};
	},
	headset: (data) => {
		return {
			icon: Headset,
			featureName: "Headset",
			name: "headset",
			tooltip: {
				included: "You have a headset in your cart.",
				missing: "You do not have a headset with your build.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}) }
		};
	},
	keyboard: (data) => {
		return {
			icon: Keyboard,
			featureName: "Keyboard",
			name: "keyboard",
			tooltip: {
				included: "You have a keyboard in your cart.",
				missing: "You do not have a keyboard with your build.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}) }
		};
	},
	mouse: (data) => {
		return {
			icon: Mouse,
			featureName: "Mouse",
			name: "mouse",
			tooltip: {
				included: "You have a mouse in your cart.",
				missing: "You do not have a mouse with your build.",
				..._get(data, "tooltip", {})
			},
			size: { ...defaultSize, ..._get(data, "size", {}) }
		};
	}
};

export default function iconFeatures(name, data = {}) {
	return icons[name](data);
}